
import { SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT } from "src/store/slice/model/Cart";
import store from "src/storeWire";
import { isString } from "underscore";
import ProductRepository from "../../repository/ProductRepository";

class openQuoteAPICallResponseMaker {
    data = {};
    data_to_send = {};

    constructor(data) {
        //this.data_to_send = {};
        this.data = data;
    }


    process = async () => {
        if (this.data.data.quoteItems) {
            if (_.isArray(this.data.data.quoteItems)) {
                let quoteLineItems = {};
                this.data.data.quoteItems.map((v) => {
                    let quoteLineItemId = " " + v.quoteLineItemId;
                    quoteLineItems[quoteLineItemId] = v;
                    if (isString(quoteLineItems[quoteLineItemId].partNumber)) {
                        quoteLineItems[quoteLineItemId].partNumber = quoteLineItems[quoteLineItemId].partNumber.trim();
                    }
                    quoteLineItems[quoteLineItemId].ERPPartNumber = quoteLineItems[quoteLineItemId].partNumber;
                    if (quoteLineItems[quoteLineItemId].ERPPartNumber == null || quoteLineItems[quoteLineItemId].ERPPartNumber == " " || quoteLineItems[quoteLineItemId].ERPPartNumber == "") {
                        quoteLineItems[quoteLineItemId].ERPPartNumber = quoteLineItems[quoteLineItemId].itemNumber;
                    }
                });

                quoteLineItems = await new ProductRepository().getProductInventoryPriceWithCpn(quoteLineItems, true);
                
                // // Array                
                // quoteLineItems = await new ProductRepository().attachProductAndInventoryToAnyObjectNewTest(this.data.data.quoteItems, true, true);
                
                this.data_to_send.openQuoteList = { count: this.data.data.total, records: quoteLineItems };
            }
        } else {
            this.data_to_send.openQuoteList = { count: 0, records: [] };
        }

        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default openQuoteAPICallResponseMaker;